export default __webpack_public_path__ + "static/choose-templates-1-85fb185c7cec8ee9c81f6f6c200633b9.png";